<template>
  <div class="headerbox">
    <div class="header">
      <div class="box">
        <img v-if="logoIndex==1&&$route.path=='/'" class="logo" src="../../../static/estate_mtxlogo_white.png" @click="$router.push({path:'/'})">
        <img v-if="logoIndex==1&&$route.path!='/'" class="logo" src="../../../static/estate_mtxlogo.png" @click="$router.push({path:'/'})">
        <img v-if="logoIndex==2" class="logo" src="../../../static/estate_mllogo.png" @click="$router.push({path:'/'})">
        <img v-if="logoIndex==3" class="logo" src="../../../static/estate_zmflogo.png" @click="$router.push({path:'/'})">
        <img v-if="logoIndex==4" class="logo" src="../../../static/estate_mdrlogo.png" @click="$router.push({path:'/'})">
        
        <!-- <el-dropdown placement="top-start" v-if="!sltCity">
          <span><i class="m-icon mi-sltcity"></i>{{storage.get('city').city}}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :key="index" v-for="(item,index) in cityItems" @click.native="changeCity(item)">{{item.city}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <div class="citywrap" @mouseleave="showCityBox=0">
          <span @mouseenter="showCityBox=1"><i class="m-icon mi-sltcity"></i>{{storage.get('city').city}}</span>
          <div class="citybox clearfix" v-show="showCityBox">
            <div class="c-left">
              <div class="citylist" :key="indexs" v-for="(items,indexs) in cityItems" v-if="indexs<cityItems.length/2+1">
                <label>{{items.letter}}</label>
                <span :key="index" v-for="(item,index) in items.data" @click="changeCity(item)">{{item.city}}</span>
              </div>
            </div>
            <div class="c-right">
              <div class="citylist" :key="indexs" v-for="(items,indexs) in cityItems" v-if="indexs>=cityItems.length/2+1">
                <label>{{items.letter}}</label>
                <span :key="index" v-for="(item,index) in items.data" @click="changeCity(item)">{{item.city}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="nav" v-if="!sltCity">
          <router-link :key="index" v-for="(item,index) in navItems" :to="{path:item.path}">{{item.name}}</router-link>
        </div>
      </div>
    </div>
    <div class="search-bar" v-if="!sltCity">
      <div class="box">
        <el-input placeholder="请输入关键字" v-model="searchWord">
          <el-button slot="append" icon="el-icon-search" class="search-icon" @click="search()"></el-button>
        </el-input>
        <div class="hot-tag">
          <span>热门搜索：</span>
          <slot v-if="tagItems.length!=0">
            <a @click="hotClick(item.pkId)" :key="index" v-for="(item,index) in tagItems" target="_blank">{{item.name}}</a>
          </slot>
          <slot v-else><span class="nodata">{{msg}}</span></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import domain from '../../store/domain.js';
import pinyin from '../../store/pinyin.js';
export default {
  name: 'Header',
  inject:['reload'],
  props:{
    sltCity:Boolean,
    kword:String
  },
  data () {
    return {
      cityItems:this.storage.get('cityItems'),
      searchWord:this.kword,
      navItems:[
        {path:'/',name:'首页'},
        {path:'/estate',name:'全部楼盘'},
        {path:'/estateSale',name:'在售楼盘'},
        {path:'/findHouse',name:'帮我找房'},
        {path:'/calculate',name:'房贷计算器'},
      ],
      tagItems:[],
      msg:'正在加载…',
      logoIndex: this.$store.state.domainIndex, 
      currCityLetter:0,
      showCityBox:0,
    }
  },
  mounted(){
    var _this = this;

    _this.getHotKey();
    _this.sortCity();
  },
  created(){
    var _this = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key == 13 && (_this.$route.path=='/estate'||_this.$route.path=='/estateSale')) {
        _this.search();
      }
    }
  },
  methods:{
    changeCity:function(city){
      this.storage.set('city',city);
      this.resetStorage('watchStorage', city);
      domain.change(city.cityCode);
    },
    getHotKey:function(){
      this.$http.get('/api/index/getHotSearch').then((response)=>{
        this.tagItems = response.data.result;
        if(this.tagItems.length==0){
          this.msg="暂无数据"
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
    hotClick:function(id){
      this.$router.push({path:'/estateDetail?estateId='+id});
      this.reload();
    },
    search:function(){
      this.searchWord==undefined?this.searchWord='':'';
      if(this.$route.path=='/estate'||this.$route.path=='/estateSale'){
        this.$emit('getKeyword',this.searchWord);
      }else{
        this.$router.push({path:'/estate?q='+this.searchWord});
      }
      
    },
    sortCity(){
      var _this = this;
      _this.cityItems=pinyin.pySegSort(_this.cityItems);
    },
    letterClick(index){
      this.currCityLetter = index;
    }
  },
}
</script>

<style scoped>
.header{padding:20px 0 10px;line-height:30px;height:30px;border-bottom:1px solid #eee;background:#fff;}
.logo{float:left;height:40px;margin-top:-10px;margin-right:20px;}

.citywrap{float:left;position:relative;z-index:10;}
.citywrap span{cursor:pointer;}
.mi-sltcity{margin-right:5px;width:12px;height:15px;background-position:-32px 0;}
.citybox{position:absolute;left:0;top:34px;width:470px;background:#fff;box-shadow:0 0 5px rgba(0,0,0,0.2);padding:10px 20px 10px 5px;}
.citybox:before{content:"";position:absolute;left:19px;top:-18px;border:9px solid transparent;border-bottom-color:#ddd;}
.citybox:after{content:"";position:absolute;left:19px;top:-17px;border:9px solid transparent;border-bottom-color:#fff;}
.citylist{line-height:25px;position:relative;padding-left:23px;}
.citylist+.citylist{margin-top:8px;}
.citylist label{width:20px;text-align:center;position:absolute;left:5px;top:0;color:#aaa;font-size:12px;}
.citylist span{display:inline-block;margin:0 0 0 15px;cursor:pointer;color:#666;vertical-align:top;font-size:13px;}
.citylist span:hover{text-decoration:underline;color:#333;}
.c-left,.c-right{width:50%;float:left;}

.nav{float:right;font-size:15px;}
.nav a{margin-left:30px;position:relative;}
.nav a.active{color:#ffd03d;font-weight:bold;cursor:default;}
.nav a.active:hover:after{display:none;}
.nav a:hover:after{content:"";position:absolute;left:0;right:0;height:0;bottom:-1px;border-bottom:1px solid #333;}
.search-bar{background:#f5f5fa;padding:15px 0;border-bottom:1px solid #eee;height:48px;}
.search-bar .el-input{width:30%;float:left;}
.search-bar .search-icon{background-color:#ffd03d;color:#333;border-top-left-radius:0;border-bottom-left-radius:0;}
.hot-tag{margin-left:4%;width:66%;float:left;margin-top:10px;line-height:20px;height:20px;white-space:nowrap;overflow:hidden;font-size:13px;}
.hot-tag>span{float:left;line-height:19px;margin-top:1px;}
.hot-tag .nodata{color:#999;margin-left:10px;}
.hot-tag a{margin-left:10px;font-size:13px;color:#666;cursor:pointer;}
.hot-tag a:hover{color:#333;text-decoration:underline;}
/*.el-dropdown-menu{width:350px;padding:10px;}
.el-dropdown-menu__item{display:inline-block;width:70px;padding:0;text-align:center;}*/
.headerbox >>> .el-input-group__append{border-color:#ffd03d;border-right:0;}
</style>



// WEBPACK FOOTER //
// src/components/public/Header.vue